import { App, Form, Input, Modal } from 'antd';
import { useResetPassword } from '@/hooks/useUsers';
import type { UserDto } from '@/types/user';

interface Props {
  user: UserDto | null;
  onClose: () => void;
}

interface FormValues {
  newPassword: string;
  confirm: string;
}

export function UserResetPasswordModal({ user, onClose }: Props) {
  const { message } = App.useApp();
  const [form] = Form.useForm<FormValues>();
  const mutation = useResetPassword();

  const handleOk = async () => {
    if (!user) return;
    try {
      const values = await form.validateFields();
      await mutation.mutateAsync({
        id: user.id,
        request: { newPassword: values.newPassword },
      });
      message.success(`Password reseteada para ${user.fullName}.`);
      form.resetFields();
      onClose();
    } catch (err: any) {
      if (err?.errorFields) return;
    }
  };

  return (
    <Modal
      title={user ? `Resetear password de ${user.fullName}` : 'Resetear password'}
      open={user != null}
      onCancel={() => { form.resetFields(); onClose(); }}
      onOk={handleOk}
      okText="Resetear"
      cancelText="Cancelar"
      confirmLoading={mutation.isPending}
      destroyOnClose
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          label="Nueva password"
          name="newPassword"
          rules={[
            { required: true, message: 'Password requerida.' },
            { min: 8, message: 'Minimo 8 caracteres.' },
          ]}
        >
          <Input.Password placeholder="Minimo 8 caracteres" autoFocus />
        </Form.Item>

        <Form.Item
          label="Confirmar password"
          name="confirm"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: 'Confirma la password.' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) return Promise.resolve();
                return Promise.reject(new Error('Las passwords no coinciden.'));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
}
